export default function CTA() {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"></div>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-amber-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-yellow-500 rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-2xl p-12 lg:p-16 text-center border border-slate-200">
          <div className="mb-8">
            <div className="inline-block w-20 h-20 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-xl">
              <i className="ri-customer-service-2-line text-white text-4xl"></i>
            </div>
            <h3 className="text-4xl lg:text-5xl font-bold mb-6 bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent leading-tight" style={{ fontFamily: '"Noto Serif JP", serif', letterSpacing: '0.02em' }}>
              インプラント治療について<br />
              不安点や疑問がございましたら<br />
              お気軽にご相談ください。
            </h3>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto mb-8"></div>
            <p className="text-lg text-slate-600 font-light">
              経験豊富な専門医が、あなたに最適な治療プランをご提案いたします
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <a 
              href="#contact" 
              className="group inline-flex items-center justify-center px-12 py-6 bg-gradient-to-r from-amber-400 to-yellow-500 text-slate-900 text-xl font-bold rounded-full hover:from-amber-500 hover:to-yellow-600 transition-all shadow-2xl hover:shadow-amber-500/50 hover:scale-105 whitespace-nowrap"
            >
              <i className="ri-calendar-check-line mr-3 text-2xl"></i>
              無料カウンセリング予約
              <i className="ri-arrow-right-line ml-3 text-2xl group-hover:translate-x-1 transition-transform"></i>
            </a>
            <a 
              href="tel:078-453-0828" 
              className="inline-flex items-center justify-center px-12 py-6 bg-white border-2 border-slate-300 text-slate-900 text-xl font-bold rounded-full hover:bg-slate-50 hover:border-slate-400 transition-all shadow-xl whitespace-nowrap"
            >
              <i className="ri-phone-line mr-3 text-2xl"></i>
              078-453-0828
            </a>
          </div>

          <div className="mt-10 pt-10 border-t border-slate-200">
            <div className="grid md:grid-cols-3 gap-6 text-sm text-slate-600">
              <div className="flex items-center justify-center">
                <i className="ri-time-line text-amber-500 mr-2 text-lg"></i>
                <span className="font-light">平日 9:30-18:30</span>
              </div>
              <div className="flex items-center justify-center">
                <i className="ri-calendar-line text-amber-500 mr-2 text-lg"></i>
                <span className="font-light">土曜日も診療</span>
              </div>
              <div className="flex items-center justify-center">
                <i className="ri-shield-check-line text-amber-500 mr-2 text-lg"></i>
                <span className="font-light">10年保証制度</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}